/**
 *
 * Please note:
 * This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit this file manually.
 *
 */

@file:Suppress(
    "ArrayInDataClass",
    "EnumEntryName",
    "RemoveRedundantQualifierName",
    "UnusedImport"
)

package org.openapitools.client.models


import kotlinx.serialization.*
import kotlinx.serialization.descriptors.*
import kotlinx.serialization.encoding.*

/**
 * 
 *
 * @param componentId 
 * @param componentType 
 */
@Serializable

data class NewLoop (

    @SerialName(value = "componentId") val componentId: kotlin.String? = null,

    @SerialName(value = "componentType") val componentType: kotlin.String? = null

)

